<template>
  <div
    tabindex="0"
    :class="[
      'form-wizard-preview-frame',
      {
        'form-wizard-preview-frame--fullscreen': isFullScreen
      }
    ]"
    @keydown.esc="onCloseFullScreen"
  >
    <div
      class="form-wizard-preview-frame__overlay"
      @click="onCloseFullScreen"
    ></div>

    <div ref="body" class="form-wizard-preview-frame__body">
      <div
        ref="container"
        class="form-wizard-preview-frame__body__inner"
        :style="containerStyles"
      >
        <slot />
      </div>
    </div>

    <div class="form-wizard-preview-frame__title">Live preview</div>

    <div class="form-wizard-preview-frame__buttons">
      <a
        v-if="isFullScreen"
        key="close"
        class="form-wizard-preview-frame__buttons__button form-wizard-preview-frame__buttons__button--close"
        @click="onToggleFullScreenMode"
      >
        <div class="icon-close"></div>
      </a>

      <a
        v-else
        key="expand"
        class="form-wizard-preview-frame__buttons__button form-wizard-preview-frame__buttons__button--expand"
        @click="onToggleFullScreenMode"
      >
        <div class="icon-expand"></div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormWizardPreviewFrame',
  props: {},
  data() {
    return {
      isFullScreen: false,
      containerHeight: undefined
    }
  },
  computed: {
    containerStyles() {
      return {
        height: this.isFullScreen ? undefined : this.containerHeight + 'px'
      }
    }
  },
  watch: {
    isFullScreen() {
      this.$refs.body.scrollTo({
        top: 0
      })
    }
  },
  mounted() {
    this.layout()
  },
  updated() {
    this.layout()
  },
  methods: {
    layout() {
      this.containerHeight = this.$refs.container.scrollHeight * 0.35
    },
    onCloseFullScreen() {
      this.isFullScreen = false
    },
    onToggleFullScreenMode() {
      this.isFullScreen = !this.isFullScreen
    }
  }
}
</script>

<style lang="scss" scoped>
.form-wizard-preview-frame {
  position: relative;
  z-index: 100;
  outline: none;
  flex: 1 1 auto;

  &__buttons {
    &__button {
      position: fixed;
      display: block;
      cursor: pointer;

      &--expand {
        background: $gray-100;
        color: $gray-700;
        padding: 0.65rem;
        font-size: 1.75rem;
        top: $header-height + 1rem;
        right: 2rem;
      }

      &--close {
        color: #fff !important;
        top: 1rem;
        right: 0;
        font-size: 1.35rem;
      }
    }
  }

  &__title {
    font-size: 1rem;
    line-height: 2rem;
    color: $gray-500;
    text-align: center;
    position: absolute;
    top: 1.5rem;
    left: 0;
    right: 0;
  }

  &__body {
    position: absolute;
    top: 0rem;
    bottom: 0;
    left: 0;
    width: $preview-original-width;
    background: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 5rem 0 2rem;

    &__inner {
      transform: scale($preview-scale, $preview-scale);
      transform-origin: left top;
    }
  }

  &__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #000;
    opacity: 0;
    transition: opacity 200ms linear;
    pointer-events: none;
  }

  &--fullscreen & {
    &__buttons {
      position: fixed;
      top: 1.5rem;
      width: $preview-original-width;
      left: 50%;
      transform: translate(-50%, 0);
    }

    &__body {
      position: fixed;
      top: $header-height;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: $header-height;
      padding: 1rem 0;

      &__inner {
        transform: translate(0, 0);
        width: 1200px;
      }
    }

    &__title {
      display: none;
    }

    &__overlay {
      opacity: 0.85;
      pointer-events: bounding-box;
    }
  }
}
</style>
